import { render, staticRenderFns } from "./customer-contact-detail.vue?vue&type=template&id=b1590294"
import script from "./customer-contact-detail.vue?vue&type=script&lang=js"
export * from "./customer-contact-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports